// Navigation dropdown functionality
document.addEventListener('DOMContentLoaded', function() {
  initializeNavigation();
  
  // Close mobile menu when clicking outside
  document.addEventListener('click', function(event) {
    const mobileNav = document.getElementById('mobile-nav');
    const toggle = document.querySelector('.mobile-menu-toggle');
    
    if (mobileNav && toggle && !mobileNav.contains(event.target) && !toggle.contains(event.target)) {
      mobileNav.classList.remove('active');
    }
  });
});

// Initialize navigation functionality
function initializeNavigation() {
  // Mobile menu functionality
  const toggleMobileMenu = () => {
    const mobileNav = document.getElementById('mobile-nav');
    if (mobileNav) {
      mobileNav.classList.toggle('active');
    }
  };

  // Set up mobile menu toggle event listener
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  if (mobileMenuToggle) {
    // Remove existing listeners to avoid duplicates
    mobileMenuToggle.replaceWith(mobileMenuToggle.cloneNode(true));
    const newToggle = document.getElementById('mobile-menu-toggle');
    newToggle.addEventListener('click', toggleMobileMenu);
  }

  // Handle dropdown menus with improved hover functionality
  const dropdowns = document.querySelectorAll('.nav-dropdown');
  
  dropdowns.forEach((dropdown, index) => {
    const toggle = dropdown.querySelector('.nav-dropdown-toggle');
    const menu = dropdown.querySelector('.nav-dropdown-menu');
    let hideTimeout;
    let isMenuVisible = false;
    
    if (!toggle || !menu) {
      return;
    }
    
    function showMenu() {
      clearTimeout(hideTimeout);
      if (!isMenuVisible) {
        menu.style.display = 'block';
        // Force reflow
        menu.offsetHeight;
        menu.classList.add('show');
        isMenuVisible = true;
      }
    }
    
    function hideMenu() {
      if (isMenuVisible) {
        menu.classList.remove('show');
        isMenuVisible = false;
        hideTimeout = setTimeout(() => {
          menu.style.display = 'none';
        }, 300);
      }
    }
    
    function cancelHide() {
      clearTimeout(hideTimeout);
    }
    
    // Show menu when hovering over toggle
    toggle.addEventListener('mouseenter', () => {
      showMenu();
    });
    
    toggle.addEventListener('mouseleave', () => {
      // Longer delay to allow moving to menu
      setTimeout(() => {
        if (!dropdown.matches(':hover')) {
          hideMenu();
        }
      }, 200);
    });
    
    // Show menu when hovering over menu itself
    menu.addEventListener('mouseenter', () => {
      showMenu();
      cancelHide();
    });
    
    // Hide menu when leaving the entire dropdown container
    dropdown.addEventListener('mouseleave', hideMenu);
    
    // Prevent menu from hiding when moving within dropdown
    dropdown.addEventListener('mouseenter', cancelHide);
    
    // Handle focus for accessibility
    toggle.addEventListener('focus', showMenu);
    toggle.addEventListener('blur', (e) => {
      // Only hide if focus is not moving to menu or its children
      setTimeout(() => {
        if (!dropdown.contains(document.activeElement)) {
          hideMenu();
        }
      }, 100);
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        hideMenu();
      }
    });
    
    // Handle escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isMenuVisible) {
        hideMenu();
        toggle.focus();
      }
    });
  });
}

// Support for Turbo navigation
document.addEventListener('turbo:load', function() {
  initializeNavigation();
}); 